module.exports = __webpack_public_path__ + "img/album_bunner_202511.5d60c922.jpg";